import { useDispatch } from "react-redux"
import { AnyAction } from "redux"
import { ThunkDispatch } from "redux-thunk"
import { SharedStoreState } from "./SharedStoreState"

export type ReduxDispatch = ThunkDispatch<SharedStoreState, any, AnyAction>
export function useReduxDispatchShared() {
    return useDispatch<ReduxDispatch>()
}
